@if (!activeExpeditionId) {
  <div class="no-browser-session-hint">
    <fa-icon [icon]="faExclamationCircle"></fa-icon>
    No active browser session.
    <wm-start-browser-session-action></wm-start-browser-session-action>
  </div>
}
@if (activeExpeditionId) {
  <div class="tools">
    @for (tool of tools; track tool) {
      <div class="tool">
        <div class="tool-header">
          <div class="label">
            {{ tool.label }}
            <fa-icon
              [icon]="faQuestionCircle"
              size="lg"
              class="info"
              [pTooltip]="tool.tooltip">
            </fa-icon>
          </div>
          <div class="switcher">
            <p-toggle-switch
              [(ngModel)]="tool.enabled"
              (onChange)="setScriptExecution(tool.label, $event.checked)">
            </p-toggle-switch>
          </div>
        </div>
      </div>
    }
  </div>
}
